import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";


// if (initialValues.cover) {

// }

export const getBase64 = (img, callback, check) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  try {
    reader.readAsDataURL(img);
  } catch (error) {
    if (!check) {
      const decodedString = atob(img);
      let bytes = new Uint8Array(decodedString.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = decodedString.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: 'image/png' });
      getBase64(blob, callback, true);
    }
  }
};

export const beforeUpload = (file) => {
  return false;
};

export const uploadButton = (loading = false) => (
  <button
    style={{
      border: 0,
      background: "none",
    }}
    type="button"
  >
    {loading ? <LoadingOutlined /> : <PlusOutlined />}
    <div
      style={{
        marginTop: 8,
      }}
    >
      Upload
    </div>
  </button>
);
